import React from 'react'
import Container from '@material-ui/core/Container';
import terreno from '../../assets/terreno2.png';

const Section1 = () => {

  const [view, setView] = React.useState(false);

  const scrollView = () => {
    setView(!view)
    view && document.getElementById('terreno').scrollIntoView()

  }

  return (
    <div id='terreno' className='section'>
        <Container className='relative flex flexCol'>
          
        <div className="floatTitle shadow">
              <h2>Terreno</h2>
              <p>Lote irregular de 1344 m2<br />lindero a la playa
              </p>
              <button className='btnBox flex flexRow horiCenter' onClick={() => scrollView()} href="https://goo.gl/maps/MdLmZbAwvsrBmAyu5" target='_blank' rel="noreferrer">{view ? 'Minimizar Terreno' : 'Ver Terreno Completo' } <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.43 18.82C14.24 18.82 14.05 18.75 13.9 18.6C13.61 18.31 13.61 17.83 13.9 17.54L19.44 12L13.9 6.46C13.61 6.17 13.61 5.69 13.9 5.4C14.19 5.11 14.67 5.11 14.96 5.4L21.03 11.47C21.32 11.76 21.32 12.24 21.03 12.53L14.96 18.6C14.81 18.75 14.62 18.82 14.43 18.82Z" fill="#fff"/>
              <path d="M20.33 12.75H3.5C3.09 12.75 2.75 12.41 2.75 12C2.75 11.59 3.09 11.25 3.5 11.25H20.33C20.74 11.25 21.08 11.59 21.08 12C21.08 12.41 20.74 12.75 20.33 12.75Z" fill="#fff"/>
              </svg>
              </button>

            </div>
              <img className={view ? 'terrenoImg view' : 'terrenoImg'} src={terreno} alt="Terreno"/>
        </Container>
    </div>
  )
}

export default Section1